var _title, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _polygon, _polygon2, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _polygon3, _polygon4, _polygon5, _path33, _path34, _path35, _polygon6, _path36, _polygon7, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _polygon8, _path44, _polygon9, _path45, _path46, _path47, _polygon10, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _polygon11, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _polygon12, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _polygon13, _path108, _path109, _path110, _path111, _polygon14, _polygon15, _path112, _path113, _path114, _path115, _path116, _polygon16, _polygon17, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _polygon18, _path140, _path141, _path142, _path143, _path144, _polygon19, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _polygon20, _polygon21, _path164, _path165, _polygon22, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _path173, _polygon30, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _polygon37, _polygon38, _polygon39, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _polygon40, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _ellipse, _path262, _ellipse2, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFuriaHead = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290.03,
    height: 301.83,
    viewBox: "0 0 290.03 301.83",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "furia_head")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284,241.72c-.77-16.78-1.9-34.11-3.58-49.09,0,.83-.1,1.66-.14,2.49C281.64,210,282.92,225.78,284,241.72Z",
    transform: "translate(-0.05 -0.02)",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.33,300h1c-.38-5.7-.76-11.56-1.15-17.54Z",
    transform: "translate(-0.05 -0.02)",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.07,188.45c-.66,5.19-1.24,10.29-1.74,15.17l-.12,16.74c1-10.13,2-20.09,2.91-29.67Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#bd3339"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M254.47,216.53h-.1c-.66,5.83-1.32,11.07-1.93,15.54v.68l-.09.07C251,242.55,250,248.4,250,248.4c.39-3.36.71-6.65,1-9.91-4.81,15.07-19.8,20.37-19.8,20.37l-66.88,35a47.67,47.67,0,0,1-41.42.91l-51.08-28c-26.81-14-34.53-25.17-36.65-31.27-1.22,19.42-2,40.85-2.4,64.44H255.55C256.32,268.32,255.89,240.65,254.47,216.53Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#bd3339"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.21,220.37c-2.58,26.88-5.1,54.87-7,79.63H9.65Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.65,300l2.09-80.05c-.39-5.26-.75-10.52-1-15.78q-.29-5.54-.47-11.07l-1.13-2.4c-1,9.58-1.94,19.54-2.91,29.67L9.65,300Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.22,184.51c-3.95,24.75-5.77,46.56-3,58.54,0,0,.8-17.42,3.08-39.43l.13-18.6Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.46,185l-.13,18.6c.51-4.88,1.08-10,1.74-15.17Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36,182.31C3.74,194.23,2.61,204.46,2,211.67c0,0,2.25-12.2,5.88-28.66l-2.25-.59Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.85,141.6q-.93,5.08-1.78,10.07l1.66-.39Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.41,65.85c-11,10.52-21.64,30.06-30,63.87a9.16,9.16,0,0,1,.12,1.56L49,178.86l191.87,2.37.59-47.58a9.11,9.11,0,0,1,.77-3.56C212.05,16,142.59,75.16,142.59,75.16a73,73,0,0,0-20.11-15.23C111.7,57.71,95.34,56.86,79.41,65.85Zm99.41,112.52c-3.25,0-5.84-3.54-5.78-7.82s2.73-7.71,6-7.67,5.84,3.54,5.78,7.82S182.07,178.41,178.82,178.37Zm38-15.56a80.35,80.35,0,0,0,14.46,11.13c-3.65.36-11.3-4.6-11.3-4.6-33.75-25.15-54.33-.67-54.33-.67C182.35,132.37,216.85,162.81,216.85,162.81ZM108.41,175.49c-3.25,0-5.84-3.54-5.78-7.82s2.73-7.71,6-7.67,5.84,3.54,5.78,7.82S111.66,175.53,108.41,175.49Zm15.25-7.35s-20-25-54.33-.67c0,0-7.76,4.77-11.41,4.32A80.35,80.35,0,0,0,72.65,161S107.89,131.45,123.66,168.14Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#f2b99a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M252.44,232.75v-.68l-.1.76Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#f2b99a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.11,254.67a1.14,1.14,0,0,0-.14-.56q-.72.68-1.42,1.23C151.4,255.42,152.1,255.41,152.11,254.67Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#f2b99a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M249.57,216.47a9.14,9.14,0,0,1-9-9.25l.32-26L49,178.86l-.32,26a9.14,9.14,0,0,1-9.25,9l-2.66,0q-.89,10.42-1.6,21.73c2.12,6.1,9.84,17.28,36.65,31.27l51.08,28a47.67,47.67,0,0,0,41.42-.91l66.88-35s15-5.3,19.8-20.37q1-11.36,1.38-22Zm-95.64,38.22c0,1.69-1.07,1.7-2.76,1.68a7.59,7.59,0,0,1-1.34-.49c-11,7.63-19.53-7.14-19.53-7.14l1.51.73c1.61-1.16,6.79-4.64,9.26-3.31.47.25,1.71,1.13,2.31,1.56.61-.41,1.87-1.26,2.35-1.5,2.52-1.27,7.38,2.48,8.85,3.7l1.41-.62A32.58,32.58,0,0,1,153.1,253,2.05,2.05,0,0,1,153.92,254.69Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#f2b99a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7,48.79a77.35,77.35,0,0,0-12.13,8.93l-1.8,11A99.48,99.48,0,0,1,60.7,48.79Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.44,46.45c3.65-5.5,7.49-8.92,11.48-9.51A112.16,112.16,0,0,1,77.18,23.78a20.09,20.09,0,0,1-3.91-4.26C90.8,9.43,111.93,5.29,131.93,3.89,83.75-9.63,53.6,13.71,35.85,51.28Q38,48.79,40.44,46.45Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.09,97.74a18.59,18.59,0,0,0-3.2,3.66,7.49,7.49,0,0,1,2.6.77Q36.74,99.94,37.09,97.74Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.87,121.88h0l3.49,0q.53-2.89,1.14-5.74a20.76,20.76,0,0,0-5,5.83l.33-.14Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.48,230.5l.21-16.69-2.66,0H30.85q.06,15,1,31.94s-1.83-12.86-3.06-32h-1l-3.49-1.55a8.33,8.33,0,0,1-3.43-2.84l-.93,75.1L16.71,300h16c.35-23.59,1.17-45,2.4-64.44A9.65,9.65,0,0,1,34.48,230.5Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.89,284.44l.93-75.1a8.33,8.33,0,0,1-1.54-4.91l.07-5.4h0l-.06,4.79-5-10.72q.19,5.53.47,11.07c.27,5.26.63,10.52,1,15.78L13.65,300h3.06Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "19.55 178.48 19.55 178.48 19.69 167.68 19.55 178.48",
    fill: "#db3d35"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "19.55 178.48 19.46 186.05 19.3 199.02 19.3 199.02 19.55 178.48 19.55 178.48",
    fill: "#db3d35"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.35,123.34l3.2-1.32a20.76,20.76,0,0,1,5-5.83q1.12-5.26,2.52-10.3l0-1.82v-.16h.24c0-.26.07-.51.09-.77h-.32v-.06h.33c0-.3.07-.6.1-.9a7.49,7.49,0,0,0-2.6-.77c-3.27,4.7-6.56,12.23-9.72,21.21l0,1.35A8.34,8.34,0,0,1,25.35,123.34Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.44,46.45a93.69,93.69,0,0,1,11.48-9.51C47.93,37.52,44.09,40.94,40.44,46.45Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.89,101.4a18.59,18.59,0,0,1,3.2-3.66,93.78,93.78,0,0,1,9.68-29l1.8-11C33.4,71.44,25.38,90.51,24.33,115.05q1-4.22,2-8.3A6.81,6.81,0,0,1,33.89,101.4Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.17,122.61c3.16-9,6.45-16.5,9.72-21.21a6.81,6.81,0,0,0-7.58,5.35q-1,4.07-2,8.3c-.06,1.31-.1,2.63-.12,4Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37,102.47q.91-3,1.93-5.91a7.78,7.78,0,0,0-1.85,1.19q-.35,2.2-.6,4.44Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M44.32,83.76c14.85-29.62,42-44.43,90.5-20a61.84,61.84,0,0,0-12.36-3.79,73,73,0,0,1,20.11,15.23l-3.13-9.65-7.58-34.16Q86.72,33.18,60.7,48.79a99.48,99.48,0,0,0-13.93,20Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M49.46,129.72c8.31-33.81,18.91-53.35,30-63.87-14.63,8.26-28.89,24.81-38.13,56.22A9.13,9.13,0,0,1,49.46,129.72Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M34.69,213.81l-.21,16.69a9.65,9.65,0,0,0,.67,5.07q.71-11.31,1.6-21.73Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M36.49,102.17c0,.3-.07.6-.1.9h-.33v.06h.32c0,.26-.07.51-.09.77H36v.16l0,1.82q.48-1.72,1-3.41Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M44.32,83.76l2.44-15a93.78,93.78,0,0,0-9.68,29,7.78,7.78,0,0,1,1.85-1.19A110,110,0,0,1,44.32,83.76Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M279.64,187.53q.34,3.76.68,7.6c0-.83.1-1.66.14-2.49q-.31-2.78-.65-5.45Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M224.69,28.79c14.38,6.72,26.15,15.48,35.25,26-17.56-36.54-46.81-60-90.77-50.95,22.16,1.4,46.46,5.8,66,17.69A18.36,18.36,0,0,1,224.69,28.79Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "279.54 186.92 279.73 186.87 279.73 186.87 279.54 186.92 279.54 186.92",
    fill: "#db3d35"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "261.23 214.22 261.23 214.22 261.26 211.67 261.26 211.67 261.23 214.22",
    fill: "#db3d35"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "271.02 188.94 271.02 188.94 274.11 188.2 274.11 188.2 271.02 188.94",
    fill: "#db3d35"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M268.64,128.33l.35-28.05q-5.12-27.3-25.2-43.71c13.73,18.44,20.64,43.92,23.58,70.64A8.33,8.33,0,0,1,268.64,128.33Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M274.72,197.37l-4.78,9.55v.61a8.35,8.35,0,0,1-3.79,6.87c-.79,7.14-1.66,13.72-2.51,19.54l7.89,66h8.8l-.19-17.54C278.33,254.92,276.4,224.93,274.72,197.37Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M261.29,216.6l0,0-4.29-.05-2.48,0c1.41,24.12,1.84,51.79,1.08,83.47h16l-7.89-66c-2.41,16.46-4.7,26.91-4.7,26.91C260.41,245,261.16,230.32,261.29,216.6Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "261.23 214.22 261.2 216.6 261.23 214.22 261.23 214.22",
    fill: "#db3d35"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M242.22,130.09a9.12,9.12,0,0,1,.85-1.52c-12.53-46.4-34-72.05-42.65-80.94A96.08,96.08,0,0,0,168.66,32q-5.3-.41-10.89-.64l-15.19,43.8S212.05,16,242.22,130.09Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.11 189.15 270.11 189.15 271.02 188.94 271.02 188.94 270.11 189.15",
    fill: "#db3d35"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M79.41,65.85c15.93-9,32.29-8.15,43.07-5.92C110.39,53.95,94.48,51.49,79.41,65.85Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M33.16,121.93l2.66,0,.09-7.17-.25.13a10.16,10.16,0,0,0-2.16,1.26q-.61,2.84-1.14,5.74Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M31.81,245.7q-.91-17-1-31.94l-2.1,0C30,232.84,31.81,245.7,31.81,245.7Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M35.91,114.8l.11-8.92q-1.4,5-2.52,10.3a10.16,10.16,0,0,1,2.16-1.26Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M38.94,96.55q-1,2.9-1.93,5.91a6.7,6.7,0,0,1,3.15,6h0a7.1,7.1,0,0,1-4.25,6.33L35.82,122l4.73.06c.24,0,.48,0,.72,0,9.24-31.41,23.5-48,38.13-56.22,15.07-14.36,31-11.9,43.07-5.92a61.84,61.84,0,0,1,12.36,3.79c-48.47-24.4-75.65-9.58-90.5,20L42.26,96.45A4.15,4.15,0,0,0,38.94,96.55Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M40.17,108.47h0a6.7,6.7,0,0,0-3.15-6q-.51,1.69-1,3.41l-.11,8.92A7.1,7.1,0,0,0,40.17,108.47Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M42.26,96.45l2.07-12.69a110,110,0,0,0-5.38,12.8A4.15,4.15,0,0,1,42.26,96.45Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "261.26 211.67 261.26 211.67 261.29 209.29 261.29 209.29 261.26 211.67",
    fill: "#db3d35"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M261.54,216.49,263.63,234c.85-5.83,1.72-12.41,2.51-19.54a8.31,8.31,0,0,1-1.37.74Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "262.12 141.89 262.33 124.75 262.12 141.89 262.12 141.89",
    fill: "#db3d35"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M232.27,52.53c15.63,14,22.56,41.82,24.94,72.18h.88l4.29.05,3.49,1.55a8.31,8.31,0,0,1,1.5.88c-2.94-26.73-9.85-52.2-23.58-70.64a86.62,86.62,0,0,0-18-11.19Q229.22,48.81,232.27,52.53Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M261.29,216.6c-.13,13.72-.88,28.45-2.35,44.26,0,0,2.29-10.45,4.7-26.91l-2.09-17.46Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M196.63,44c15.17-2.93,26.8.58,35.64,8.51q-3-3.71-6.46-7.15Q203.09,34.65,168.66,32a96.08,96.08,0,0,1,31.76,15.63C198,45.19,196.63,44,196.63,44Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "262.12 141.89 262.12 141.89 261.29 209.29 261.29 209.29 261.77 170.68 262.12 141.89",
    fill: "#db3d35"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M252.47,230l0,2.07c.61-4.47,1.27-9.7,1.93-15.54l-1.74,0Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M251,238.49c-.3,3.26-.62,6.56-1,9.91,0,0,1-5.85,2.37-15.58l-.14.11A30.52,30.52,0,0,1,251,238.49Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M252.64,216.51h-.27q-.35,10.62-1.38,22a30.52,30.52,0,0,0,1.22-5.56l.14-.11.1-.76,0-2.07Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M250.16,124.65c-12-40.65-31.84-63.83-49.74-77,8.66,8.89,30.12,34.54,42.65,80.94A9.13,9.13,0,0,1,250.16,124.65Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M254,105.83a2.09,2.09,0,0,1,0,.22v.55l-.22,18.06,3.44,0c-2.38-30.36-9.3-58.17-24.94-72.18A95,95,0,0,1,254,105.77Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M196.63,44s1.41,1.18,3.79,3.62c17.9,13.18,37.72,36.37,49.74,77l.54,0,3.07,0L254,106.6V106a2.09,2.09,0,0,0,0-.22v-.06a95,95,0,0,0-21.74-53.24C223.43,44.6,211.8,41.08,196.63,44Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M284,241.72c-1.13-15.94-2.41-31.68-3.73-46.59-.28,4.84-.59,9.69-1,14.55l.8,72.78c.39,6,.78,11.84,1.15,17.54h4.28C285.45,286.61,285.09,264.69,284,241.72Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M274.72,197.37c1.69,27.56,3.61,57.55,5.42,85.09l-.8-72.78c.39-4.86.71-9.71,1-14.55q-.34-3.84-.68-7.6Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "274.11 188.2 274.11 188.2 279.54 186.92 279.54 186.92 274.11 188.2",
    fill: "#db3d35"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M280.46,192.64c1.68,15,2.82,32.31,3.58,49.09,1.38,19.5,2.53,39.3,3.25,58.28h.21c1.83-25.51-1.49-70.82-5.78-113.57l-1,.23C280.66,188.65,280.57,190.64,280.46,192.64Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M279.77,186.89l.21,0-.17.34q.34,2.67.65,5.45c.11-2,.19-4,.28-6l-1,.23Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M270.62,132.16l.07-5.86c-.41-8.51-.67-15.3-.75-19.82q-.39-3.17-1-6.2l-.35,28.05A8.34,8.34,0,0,1,270.62,132.16Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M287.3,300c-.72-19-1.87-38.78-3.25-58.28,1,23,1.4,44.89,1.52,58.28Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M269.94,106.48c.08,4.52.35,11.31.75,19.82l.05-4.22A117.23,117.23,0,0,0,269.94,106.48Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M148.59,31.12l-3.62,0-2.38,44.06,6.16-44Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M131.88,31.34l7.58,34.16,3.13,9.65L145,31.09Q138.23,31.08,131.88,31.34Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M142.59,75.16l15.19-43.8q-4.43-.18-9-.24Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M254.37,216.53h.1l0-.57Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M240.86,181.23l10.61.13a367.32,367.32,0,0,0-9.25-51.28,9.11,9.11,0,0,0-.77,3.56Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M252.45,212.08l.11-9.16q0-8-.44-15.59c-.21-2-.43-4-.66-6l-10.61-.13-.32,26a9.14,9.14,0,0,0,9,9.25l2.8,0c0-1.49.08-3,.11-4.43Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M252.48,212.07c.07-3.1.1-6.16.08-9.16l-.11,9.16Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M254.9,211.75q-.23,2.15-.46,4.21l0,.57,2.48,0,.07-5.35A19.59,19.59,0,0,1,254.9,211.75Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M251.76,181.37a276.88,276.88,0,0,0-8.7-52.8,9.12,9.12,0,0,0-.85,1.52,367.32,367.32,0,0,1,9.25,51.28Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M251.76,181.37h-.3c.23,2,.45,3.94.66,6Q252,184.31,251.76,181.37Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M257.4,181.05l0,.51,0,.17Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M257.37,181.56c-.62,10.87-1.52,21.12-2.47,30.18a19.59,19.59,0,0,0,2.13-.53l.36-29.48Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M258.09,124.72h-.88c.32,4.13.56,8.31.73,12.5Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M254.19,211.88c-.49.07-1,.13-1.49.17l-.06,4.46,1.74,0,.06-.57Q254.32,213.91,254.19,211.88Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M252.56,202.91l.12-10q-.27-2.85-.56-5.63Q252.52,194.9,252.56,202.91Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M252.37,216.5h.27l.06-4.46-.21,0C252.45,213.54,252.42,215,252.37,216.5Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M252.69,212c.5,0,1-.09,1.49-.17q-.56-8.59-1.29-16.56Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M252.69,193l-.12,10c0,3,0,6.06-.08,9.16l.21,0,.21-16.72C252.83,194.54,252.76,193.74,252.69,193Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M253.9,139l-.28-1.24V139Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M254.44,216q.23-2.06.46-4.21l-.71.13Q254.32,213.9,254.44,216Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M252.83,181.38l.53-42.46.24,0v-1.2q-1.59-6.85-3.46-13.12a9.13,9.13,0,0,0-7.09,3.93,276.88,276.88,0,0,1,8.7,52.8Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M252.69,193l.14-11.57h-1.06q.21,2.94.36,6Q252.42,190.1,252.69,193Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M253.07,181.39l4.28.05v.13l0-.51.27-21.79q-1.59-10.71-3.77-20.26l-.3,0Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M257.35,181.44l-4.28-.05-.17,13.94q.72,8,1.29,16.56l.71-.13c1-9.06,1.85-19.32,2.47-30.18Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M253.6,139l-.24,0-.53,42.46h.24Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M252.9,195.33l.17-13.94h-.24L252.69,193C252.76,193.74,252.83,194.54,252.9,195.33Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M253.61,137.77l.28,1.24a19.6,19.6,0,0,1,4,.9l0-2.69c-.17-4.2-.4-8.37-.73-12.5l-3.44,0Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M253.78,124.66l-3.07,0-.54,0q1.86,6.28,3.46,13.12Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M257.91,139.9a19.6,19.6,0,0,0-4-.9q2.17,9.56,3.77,20.26Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M270.37,152.2l-.06-.06.06.19Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M268.64,128.33a8.33,8.33,0,0,0-1.27-1.12q.71,6.47,1.13,13Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M270,198.42a19.71,19.71,0,0,1-2.84,5.52q-.49,5.4-1.06,10.47a8.35,8.35,0,0,0,3.79-6.87v-.61h0Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M261.3,214.46q0-1.4,0-2.78l0,2.55Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M261.24,216.61l0,0q0-1.07,0-2.13l0-.23Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M270.38,170.8l.1-8.08h-.24l.13-10.39-.06-.19a5.21,5.21,0,0,0-1.31-1,441.19,441.19,0,0,1-1.81,52.77,19.71,19.71,0,0,0,2.84-5.52l.11-9.26Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.11 189.15 270.11 189.15 270.11 189.15 270.11 189.15",
    fill: "#ebf7fd"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M268.39,148.14l.1-7.92q-.42-6.53-1.13-13a8.31,8.31,0,0,0-1.5-.88l-3.49-1.55-.21,17.14A20,20,0,0,1,268.39,148.14Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M261.33,209.31l0,2.37q0,1.38,0,2.78l.24,2,3.23-1.34a8.31,8.31,0,0,0,1.37-.74q.56-5.06,1.06-10.47A20,20,0,0,1,261.33,209.31Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M261.54,216.49l-.24-2q0,1.06,0,2.13Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M269,151.18a3.68,3.68,0,0,0-.64-.26l0-2.78a20,20,0,0,0-6.23-6.23l-.36,28.78-.48,38.62a20,20,0,0,0,5.86-5.37A441.19,441.19,0,0,0,269,151.18Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M268.93,149.08a19.67,19.67,0,0,1,1.38,3.05l.06.06.25-20a8.34,8.34,0,0,0-2-3.84l-.15,11.9Q268.78,144.65,268.93,149.08Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M270.31,152.14a19.67,19.67,0,0,0-1.38-3.05q0,1,.07,2.09A5.21,5.21,0,0,1,270.31,152.14Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M268.49,140.22l-.1,7.92c.19.31.36.63.54.94Q268.77,144.65,268.49,140.22Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M269,151.18q0-1-.07-2.09c-.18-.32-.35-.64-.54-.94l0,2.78A3.68,3.68,0,0,1,269,151.18Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M281.64,162.86l-.46,9.29c0,2.41-.11,4.83-.18,7.25q.36,3.5.72,7l2.36-.56a7.54,7.54,0,0,0,5.8-7.24L290,171l.09-7.59a7.54,7.54,0,0,0-5.62-7.38l-2-.54-.09,7.33Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M279.77,186.89q-.29-2.3-.61-4.51.21,2.26.42,4.55Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M271.06,189l3.1-.73c-.54-8.87-1-17.42-1.51-25.48l-1.26,0Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M281,179.39c.07-2.42.14-4.84.18-7.25l.46-9.29-2.41,0C279.83,168.25,280.43,173.79,281,179.39Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.44 162.7 270.34 170.78 270.11 189.15 271.02 188.94 271.34 162.71 270.44 162.7",
    fill: "#004256"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M272.65,162.74c.46,8.05,1,16.6,1.51,25.48l5.43-1.29q-.21-2.29-.42-4.55a153.41,153.41,0,0,0-3.87-19.61Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M280.74,186.66l1-.23q-.35-3.53-.72-7Q280.9,183,280.74,186.66Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M277.29,162.8c.62,6.26,1.24,12.81,1.87,19.58q.31,2.2.61,4.51l1-.23q.15-3.64.27-7.27c-.58-5.61-1.17-11.15-1.77-16.57Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M279.17,182.38c-.63-6.77-1.25-13.32-1.87-19.58l-2,0A153.41,153.41,0,0,1,279.17,182.38Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.11 189.15 270.11 189.15 270.34 170.78 270.11 189.15",
    fill: "#004256"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.44 162.7 270.34 170.78 270.44 162.7 270.44 162.7",
    fill: "#004256"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M271.06,189l0,3.62a19.59,19.59,0,0,1-1,5.85l-.11,8.5,4.78-9.55q-.28-4.63-.56-9.15Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#d3dee4"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M279.64,187.53l.17-.35,0-.29-.19,0Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#d3dee4"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M270,198.42a19.59,19.59,0,0,0,1-5.85l0-3.62-.91.21Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#d3dee4"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M279.58,186.93l-5.43,1.29q.27,4.52.56,9.15l4.92-9.84Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#d3dee4"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M280,186.84l-.21,0,0,.29Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#d3dee4"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "270 198.41 269.89 206.91 269.89 206.91 270 198.41 270 198.41",
    fill: "#d3dee4"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.11 189.15 270 198.41 270 198.41 270.11 189.15 270.11 189.15",
    fill: "#d3dee4"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M260.72,209.65l.55,4.59,0-2.55c0-.79,0-1.57,0-2.35C261.11,209.45,260.91,209.54,260.72,209.65Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M260.72,209.65a19.72,19.72,0,0,1-3.7,1.57l-.07,5.35,4.29.05,0-2.38Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M258.13,162.49c-.13,6.31-.39,12.53-.73,18.56v.69l3.34,27.91c.19-.1.39-.2.57-.31A363.66,363.66,0,0,0,258.13,162.49Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M257,211.22a19.72,19.72,0,0,0,3.7-1.57l-3.34-27.91Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M261.31,211.68l0-2.37,0,0C261.3,210.11,261.3,210.9,261.31,211.68Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M258,139.94a19.77,19.77,0,0,1,4.13,2l.21-17.14-4.29-.05-.15,12.49Q258,138.58,258,139.94Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M258.13,162.49a363.66,363.66,0,0,1,3.17,46.84l0,0,.83-67.4a19.77,19.77,0,0,0-4.13-2C258.28,147.47,258.29,155,258.13,162.49Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M257.67,159.26l-.27,21.79c.34-6,.6-12.25.73-18.56Q257.9,160.86,257.67,159.26Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M257.94,137.21l0,2.69.13,0Q258,138.58,257.94,137.21Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M258.13,162.49c.16-7.45.15-15-.09-22.55l-.13,0-.24,19.36Q257.9,160.86,258.13,162.49Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M49.46,129.72a459,459,0,0,0-8.93,49l8.47.1.59-47.58A9.16,9.16,0,0,0,49.46,129.72Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M36.76,213.84l2.66,0a9.14,9.14,0,0,0,9.25-9l.32-26-8.47-.1C39.1,189.54,37.83,201.21,36.76,213.84Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M32.08,208.88l-.06,4.9,2.66,0,.06-4.47A19.62,19.62,0,0,1,32.08,208.88Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M32.46,178.66l2.66,0,.38-31.09q-1.8,10.75-3,23.2Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M32.46,178.66l-.37,30.22a19.62,19.62,0,0,0,2.66.47l.38-30.66Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M41.27,122.07a215.52,215.52,0,0,0-5.45,23.7l-.41,32.93,5.11.06a459,459,0,0,1,8.93-49A9.13,9.13,0,0,0,41.27,122.07Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M40.52,178.76l-5.11-.06L35,209.38l-.29,0-.06,4.47,2.07,0C37.83,201.21,39.1,189.54,40.52,178.76Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M35.51,147.6l-.38,31.09h.29l.41-32.93C35.72,146.37,35.61,147,35.51,147.6Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M34.74,209.34l.29,0,.38-30.69h-.29Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M33,136.67a19.61,19.61,0,0,1,2.67-.4l.18-14.3-2.66,0Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M33,136.67l-.42,34.13q1.13-12.48,3-23.2l.14-11.33A19.61,19.61,0,0,0,33,136.67Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M35.94,136.24l-.12,9.53a215.52,215.52,0,0,1,5.45-23.7c-.24,0-.48,0-.72,0L35.82,122l-.18,14.3Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M35.65,136.27l-.14,11.33c.1-.62.21-1.23.32-1.83l.12-9.53Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "28.83 121.86 28.83 121.86 28.83 121.86 28.83 121.86",
    fill: "#ebf7fd"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M28.54,122a57.17,57.17,0,0,0-4.49,9.49l-.12,9.81a19.94,19.94,0,0,1,4.74-3.18l.2-16.25Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M24.25,212.18l3.49,1.55.08-6.41a20,20,0,0,1-6.9-5.8l-.1,7.83A8.33,8.33,0,0,0,24.25,212.18Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M28.47,154.44l.2-16.31a19.94,19.94,0,0,0-4.74,3.18l-.23,18.35-2.28,0-.23,18.88,6.46.08C27.7,170.75,27.94,162.63,28.47,154.44Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M27.66,178.6l-6.46-.08-.28,23a20,20,0,0,0,6.9,5.8l.12-10C27.74,191.38,27.63,185.09,27.66,178.6Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M19.35,199l-.07,5.4a8.33,8.33,0,0,0,1.54,4.91l.1-7.83A19.89,19.89,0,0,1,19.35,199Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "19.79 159.6 19.69 167.68 19.55 178.48 21.15 178.5 21.39 159.62 19.79 159.6",
    fill: "#ebf7fd"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2,178.52l-1.6,0L19.35,199a19.89,19.89,0,0,0,1.57,2.47Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M25.35,123.34a8.34,8.34,0,0,0-1.2.62l-.09,7.55A57.17,57.17,0,0,1,28.54,122Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M28.47,154.44c-.53,8.19-.77,16.32-.81,24.16h.51Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M27.66,178.6c0,6.49.08,12.78.28,18.75l.23-18.74Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#ebf7fd"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M10.35,183.66l.12-.72,0-4.55h.72c.86-5.09,1.81-10.27,2.8-15.49,0-1.12.06-2.24.09-3.36h-.7c-2.06,8.2-3.92,16.25-5.51,23.48l1.83.48h0Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M13.92,175.16q-.25,1.63-.49,3.26h.51C13.93,177.34,13.92,176.25,13.92,175.16Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M6,152.63a7.54,7.54,0,0,0-5.8,7.24l-.09,7.59L0,175a7.52,7.52,0,0,0,5.31,7.27c1.27-9.38,2.85-19.8,4.71-30.64Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M14,182.15q0-1.87,0-3.73h-.51q-.43,2.92-.82,5.83l1.12.3Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5,178.38l0,4.55q.37-2.26.75-4.55Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M13.74,184.55l.28.07q0-1.24,0-2.47Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M13.92,175.16q0-6.16.11-12.26c-1,5.22-1.94,10.41-2.8,15.49l2.21,0Q13.67,176.79,13.92,175.16Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M10.47,182.94l-.12.72.11,0Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M12.62,184.25q.39-2.91.82-5.83l-2.21,0q-.39,2.29-.75,4.55v.75Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M11.63,159.51l.1-8.24-1.66.39c-1.85,10.84-3.43,21.27-4.71,30.64l.3.11,2.25.59c1.6-7.23,3.46-15.27,5.51-23.48Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M14.36,178.43c.54-5.28,1.06-10.4,1.57-15.32-.73,4-1.4,8-2,12,0,1.09,0,2.17,0,3.26Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M14.12,159.54c0,1.12-.07,2.23-.09,3.36q.32-1.67.65-3.35Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M13.94,178.43q0,1.86,0,3.73l.38-3.72Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M17.09,178.47l.23-18.88H16.6q-.34,1.76-.67,3.54c-.51,4.91-1,10-1.57,15.32Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M14.36,178.43,14,182.15q0,1.23,0,2.47l3,.78.09-6.94Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "19.79 159.6 17.28 159.57 17.04 178.45 19.55 178.48 19.69 167.68 19.79 159.6",
    fill: "#004256"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "16.96 185.39 19.46 186.05 19.55 178.48 17.04 178.45 16.96 185.39",
    fill: "#004256"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M13.92,175.16c.62-4.06,1.29-8.09,2-12l.37-3.54-1.62,0q-.33,1.68-.65,3.35Q13.9,169,13.92,175.16Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3,159.57l-.37,3.54q.33-1.78.67-3.54Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "19.69 167.68 19.79 159.6 19.79 159.6 19.69 167.68",
    fill: "#004256"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74,183.49l.48,1,.14-.86Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#d3dee4"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M12.62,184.25q-.28,2.11-.55,4.2l1.06,2.25.62-6.15Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#d3dee4"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M13.74,184.55l-.62,6.15,1.13,2.4q-.14-4.25-.23-8.48Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#d3dee4"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M10.47,183.69l-.11,0-.14.86.24.51Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#d3dee4"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M10.47,183.69V185l1.61,3.43q.27-2.09.55-4.2Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#d3dee4"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M19.35,199a19.57,19.57,0,0,1-2.39-9.6l0-4-3-.78q.08,4.23.23,8.48l5,10.72Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#d3dee4"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M17,185.41l0,4a19.57,19.57,0,0,0,2.39,9.6l.16-13Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#d3dee4"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.31 183.64 9.69 183.48 9.69 183.48 10.31 183.64 10.31 183.64",
    fill: "#d3dee4"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "12.57 184.24 12.57 184.24 13.7 184.53 13.7 184.53 12.57 184.24",
    fill: "#d3dee4"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "13.7 184.53 13.7 184.53 13.98 184.61 13.98 184.61 13.7 184.53",
    fill: "#d3dee4"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.31 183.64 10.31 183.64 10.42 183.67 10.42 183.67 10.31 183.64",
    fill: "#d3dee4"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "12.57 184.24 10.42 183.67 10.42 183.67 12.57 184.24 12.57 184.24",
    fill: "#d3dee4"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "13.98 184.61 13.98 184.61 16.96 185.39 16.96 185.39 13.98 184.61",
    fill: "#d3dee4"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "16.96 185.39 16.96 185.39 19.46 186.05 16.96 185.39",
    fill: "#d3dee4"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M32.36,121.92l-3.49,0-.2,16.25c.44-.21.89-.39,1.34-.57C30.64,132.29,31.42,127.05,32.36,121.92Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "28.83 121.86 28.83 121.86 28.83 121.86 28.83 121.86",
    fill: "#b6c0c7"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M30.85,208.54q0,2.58,0,5.23H32l.06-4.9C31.67,208.77,31.26,208.66,30.85,208.54Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M27.82,207.31l-.08,6.41h1q-.19-3-.36-6.16Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M28.67,138.13l-.2,16.31c.37-5.62.87-11.27,1.54-16.87C29.56,137.74,29.11,137.92,28.67,138.13Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M31.92,178.65h.53l.1-7.85Q32.21,174.64,31.92,178.65Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M31.92,178.65q-1,13.88-1.07,29.89c.4.13.82.24,1.23.34l.37-30.22Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M27.82,207.31l.57.26c-.17-3.27-.32-6.7-.44-10.23Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M33,136.67l.18-14.74h-.8c-.95,5.13-1.72,10.36-2.35,15.64A19.63,19.63,0,0,1,33,136.67Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M30.85,208.54a19.66,19.66,0,0,1-2.47-1q.17,3.18.36,6.16l2.1,0Q30.84,211.12,30.85,208.54Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M33,136.67a19.63,19.63,0,0,0-3,.89c-.67,5.6-1.17,11.25-1.54,16.87l-.17,13.36-.13,10.8,3.75,0q.28-4,.63-7.84Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M28.17,178.6l-.23,18.74c.12,3.54.27,7,.44,10.23a19.66,19.66,0,0,0,2.47,1q.08-16,1.07-29.89Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#b6c0c7"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "28.83 121.86 28.83 121.86 28.83 121.86 28.63 138.12 28.63 138.12 28.83 121.86",
    fill: "#b6c0c7"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "27.77 207.29 27.69 213.71 27.77 207.29 27.77 207.29",
    fill: "#b6c0c7"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    points: "28.63 138.12 28.63 138.12 28.43 154.42 28.43 154.42 28.63 138.12",
    fill: "#b6c0c7"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    points: "27.89 197.32 27.89 197.32 27.77 207.29 27.77 207.29 27.89 197.32",
    fill: "#b6c0c7"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    points: "28.13 178.59 28.26 167.79 28.43 154.42 28.43 154.42 28.13 178.59 28.13 178.59",
    fill: "#b6c0c7"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    points: "28.13 178.59 27.89 197.32 27.89 197.32 28.13 178.59 28.13 178.59",
    fill: "#b6c0c7"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M35.85,51.28c-15.53,17.59-23.38,40.61-23.72,67.6l-.28,22.73c2.27-12.41,4.88-25.1,7.79-37.18C23.13,85.32,28.4,67,35.85,51.28Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M282.42,155.54l.41-33.31c.33-26.62-7.42-49.57-22.89-67.44,13.73,28.56,20.3,65.12,21.19,100.41Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M14.45,150.63a355.16,355.16,0,0,1,5.19-46.21c-2.91,12.07-5.51,24.76-7.79,37.18l-.12,9.67Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M48.57,57.73A77.35,77.35,0,0,1,60.7,48.79,106.94,106.94,0,0,1,86.82,27.63a17.72,17.72,0,0,1-9.65-3.85A112.16,112.16,0,0,0,51.92,36.94h0Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M18.18,141.7c-.81,2.84-1.6,5.72-2.37,8.62l.76-.18q.71-3.47,1.45-6.94Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M40.44,46.45q-2.4,2.34-4.59,4.83C28.4,67,23.13,85.32,19.63,104.43,25.48,80.14,32.52,58.37,40.44,46.45Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M18.81,139.49l-.63,2.2-.16,1.5Q18.41,141.34,18.81,139.49Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M20,144.4q-.44,1.69-.87,3.44.39-.85.85-1.65Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M19.15,147.84q-.21.88-.43,1.78l1.23-.29,0-3.13Q19.54,147,19.15,147.84Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M18,143.19q-.74,3.46-1.45,6.94l.74-.17Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M24.17,122.61l-.62,1.77c.2-.15.39-.29.6-.42Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M20,144.4l.12-9.4c-.45,1.48-.89,3-1.33,4.49q-.4,1.85-.79,3.7L17.3,150l1.11-.26a19.58,19.58,0,0,1,.74-1.85Q19.58,146.09,20,144.4Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M19.15,147.84a19.58,19.58,0,0,0-.74,1.85l.31-.07Q18.94,148.72,19.15,147.84Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M18.18,141.7c2.33-22,3.93-36.34,3.93-36.34l-.25,20.4q1.23-5.43,2.48-10.7c1.05-24.54,9.08-43.61,24.24-57.33L52,36.93h0a93.69,93.69,0,0,0-11.48,9.51c-7.91,11.93-15,33.69-20.81,58a355.16,355.16,0,0,0-5.19,46.21l1.36-.32C16.58,147.42,17.37,144.54,18.18,141.7Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M20.16,133.31l0-2.35a8.34,8.34,0,0,1,1.56-4.74l.1-.46.25-20.4s-1.6,14.3-3.93,36.34l.63-2.2Q19.48,136.39,20.16,133.31Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M23.55,124.38l.62-1.77,0-3.58c0-1.34.06-2.66.12-4q-1.24,5.26-2.48,10.7v.33A8.33,8.33,0,0,1,23.55,124.38Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M20.16,133.31q-.68,3.08-1.35,6.18c.44-1.51.88-3,1.33-4.49Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M21.85,126.09v-.33l-.1.46Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M129.18,19.17c-9.82,1.32-21,3.41-30.38,6.69a28.27,28.27,0,0,1-12,1.77A106.94,106.94,0,0,0,60.7,48.79q26.09-15.66,71.18-17.45Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M224.69,28.79c-3.95,1-8.95.81-15.22-1.56a130.69,130.69,0,0,0-17.56-5.06A112.35,112.35,0,0,1,209,31.56c14.75,4.57,26.1,13.39,34.74,25Q263.92,73,269,100.27l.23-18.5s4.49,32.05,9.09,72.68l2.82.74c-.88-35.29-7.46-71.85-21.19-100.41C250.84,44.27,239.07,35.51,224.69,28.79Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M162.46,17.87l-4.68,13.5q5.58.22,10.89.64A51.12,51.12,0,0,0,161,30.46c19-3.68,34.89-3,48,1.11a112.35,112.35,0,0,0-17.12-9.39c-6-1.32-11.92-2.33-17.28-3.09C170.61,18.52,166.54,18.13,162.46,17.87Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M225.82,45.37a86.62,86.62,0,0,1,18,11.19c-8.64-11.61-20-20.42-34.74-25A108,108,0,0,1,225.82,45.37Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M161,30.46A51.12,51.12,0,0,1,168.66,32q34.45,2.68,57.16,13.38A108,108,0,0,0,209,31.56C195.91,27.49,180.07,26.77,161,30.46Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M270.14,100.21a4.49,4.49,0,0,0,.35-.43c-.4-3.38-.63-5.22-.63-5.22s2.51,2.65.63,5.22c1.06,8.92,3.34,28.65,5.92,54.17l1.89.5c-4.59-40.62-9.09-72.68-9.09-72.68l-.23,18.5q.57,3,1,6.2C269.87,102.64,269.93,100.44,270.14,100.21Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M270.61,152.43l1.48.39c-.56-10-1-18.92-1.39-26.52l-.07,5.86a8.31,8.31,0,0,1,.22,1.9Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M269.86,94.56s.23,1.84.63,5.22C272.37,97.21,269.86,94.56,269.86,94.56Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M276.41,154c-2.58-25.52-4.86-45.25-5.92-54.17a4.49,4.49,0,0,1-.35.43c-.21.23-.27,2.43-.2,6.27a117.23,117.23,0,0,1,.81,15.6l-.05,4.22c.36,7.6.83,16.57,1.39,26.52Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M148.74,31.12l1.9-13.57q-2.47,0-4.94.13L145,31.09l3.62,0Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M145,31.09l.73-13.42c-4,.16-7.94.45-11.88.91-1.5.17-3.06.37-4.64.58l2.7,12.17Q138.23,31.08,145,31.09Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M150.64,17.55l-1.9,13.57q4.61.06,9,.24l4.68-13.5Q156.56,17.49,150.64,17.55Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M270.6,153v-.56l-.24-.26v.13C270.45,152.55,270.54,152.78,270.6,153Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M270.37,152.32l-.13,10.39h.24l.12-9.71C270.54,152.78,270.45,152.55,270.37,152.32Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M270.61,152.45v0h0l.23-18.37a8.31,8.31,0,0,0-.22-1.9l-.25,20Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M281.22,160.85l.72-4.22-.31,6.22h.68l.09-7.33-1.29-.34C281.17,157.09,281.21,159,281.22,160.85Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M270.6,153a19.59,19.59,0,0,1,.83,5.87l0,3.85,1.26,0q-.24-4.1-.46-8a12.33,12.33,0,0,0-1.58-2.26Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M281.64,162.86l.31-6.22-.72,4.22c0-1.88-.05-3.77-.1-5.65l-2.82-.74q.47,4.13.93,8.37Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M271.39,162.73l0-3.85a19.59,19.59,0,0,0-.83-5.87l-.12,9.71Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M275.3,162.78a38.66,38.66,0,0,0-3.11-8.06q.22,3.92.46,8Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M277.29,162.8l1.94,0q-.47-4.24-.93-8.37l-1.89-.5Q276.85,158.27,277.29,162.8Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M272.19,154.71l-.11-1.9-1.48-.39v0A12.33,12.33,0,0,1,272.19,154.71Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M272.19,154.71a38.66,38.66,0,0,1,3.11,8.06l2,0q-.45-4.52-.88-8.85l-4.32-1.14Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.56 152.99 270.57 152.44 270.57 152.44 270.56 152.99 270.56 152.99",
    fill: "#004256"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.56 152.99 270.56 152.99 270.44 162.7 270.44 162.7 270.56 152.99",
    fill: "#004256"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.57 152.41 270.57 152.41 270.57 152.44 270.57 152.44 270.57 152.41",
    fill: "#004256"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7,138.48l-.07,5.29a20,20,0,0,1,2.31-2.45l.12-9.81C23.23,133.68,22.45,136,21.7,138.48Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M21.63,143.76l-.2,15.87,2.28,0,.23-18.35A20,20,0,0,0,21.63,143.76Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M21.63,143.76l.07-5.29q-.87,2.85-1.67,5.92l0,1.79A19.89,19.89,0,0,1,21.63,143.76Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M20,146.2l0,3.13h0l-.13,10.29,1.6,0,.2-15.87A19.89,19.89,0,0,0,20,146.2Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7,138.48c.75-2.46,1.54-4.79,2.36-7l.09-7.55c-.21.13-.4.28-.6.42q-.88,2.57-1.75,5.27Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8,129.65Q21,132.28,20.14,135L20,144.4q.81-3.07,1.67-5.92Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M20.19,131l0,2.35q.79-3.57,1.59-7.09A8.34,8.34,0,0,0,20.19,131Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M23.55,124.38a8.33,8.33,0,0,0-1.7,1.71l0,3.56Q22.67,127,23.55,124.38Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8,129.65l0-3.56-.1.13q-.8,3.52-1.59,7.09l0,1.69Q21,132.28,21.8,129.65Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M14.19,156.49q-.39,1.52-.77,3h.7c0-.92,0-1.85.08-2.77Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M14.11,153.32l.16,1.11q.07-1.9.17-3.8l-2.72.64-.1,8.24,1.79,0q.38-1.52.77-3Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M16.57,150.13l-.76.18q-.82,3.09-1.61,6.18v.29c0,.92-.05,1.84-.08,2.77h.56Q15.59,154.85,16.57,150.13Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6,159.57h.72l0-3.82Q17,157.65,16.6,159.57Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M20,149.33l-1.23.29q-.7,3-1.36,6.14l0,3.82,2.51,0Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M16.57,150.13q-1,4.71-1.89,9.42l1.62,0q.52-5,1-9.61Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M17.37,155.76v0a19.57,19.57,0,0,1,1-6L17.3,150q-.49,4.64-1,9.61h.3Q17,157.65,17.37,155.76Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M18.42,149.69a19.57,19.57,0,0,0-1,6v0q.65-3.13,1.36-6.14Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M14.11,153.32l.08,3.17q.79-3.09,1.61-6.18l-1.36.32q-.09,1.9-.17,3.8Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    points: "19.91 149.31 19.79 159.6 19.79 159.6 19.91 149.31 19.91 149.31",
    fill: "#004256"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M157.49,6.91a115.49,115.49,0,0,1,11.68-3.08c-5.05-.32-10-.48-14.74-.54-7.14-.09-14.73,0-22.49.59q4.31,1.21,8.82,2.82Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M77.18,23.78c13.78-5.18,29.79-8.54,48-9.86q1.35-.22,2.7-.41l-1.55-7,14.38.18q-4.51-1.61-8.82-2.82c-20,1.41-41.13,5.54-58.67,15.63A20.09,20.09,0,0,0,77.18,23.78Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M127.92,13.5q-1.36.19-2.7.41l2.76-.18Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M166.22,7l-2.38,6.86,1.91.33c22.93,2,42.62,7,58.94,14.58a18.36,18.36,0,0,0,10.46-7.26c-19.53-11.89-43.84-16.29-66-17.69a115.49,115.49,0,0,0-11.68,3.08Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M165.75,14.21l-1.91-.33-.06.17Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M146,12.33h.15q2.62,0,5.21.18l.52-3.69c1.9-.7,3.77-1.32,5.63-1.91l-16.74-.21c1.79.64,3.59,1.31,5.43,2Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M151.22,13.39l.12-.87q-2.59-.14-5.21-.18H146l-.05,1h.88Q149,13.32,151.22,13.39Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M146,12.33l.19-3.58c-1.84-.74-3.64-1.41-5.43-2l-14.38-.18,1.55,7A119,119,0,0,1,146,12.33Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M145.93,13.29l.05-1a119,119,0,0,0-18.07,1.17l.05.23Q136.62,13.21,145.93,13.29Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M151.34,12.51a118.84,118.84,0,0,1,12.5,1.36L166.22,7l-8.73-.11c-1.85.59-3.72,1.21-5.63,1.91Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M151.22,13.39q6.43.18,12.56.66l.06-.17a118.84,118.84,0,0,0-12.5-1.36Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M125.21,13.92C107,15.24,91,18.6,77.18,23.78a17.72,17.72,0,0,0,9.65,3.85A113.78,113.78,0,0,1,125.21,13.92Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8,25.86c9.42-3.29,20.56-5.37,30.38-6.69L128,13.73l-2.76.18A113.78,113.78,0,0,0,86.82,27.63,28.27,28.27,0,0,0,98.8,25.86Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M209.48,27.23c6.27,2.36,11.27,2.54,15.22,1.56-16.33-7.63-36-12.63-58.94-14.58a115.75,115.75,0,0,1,26.17,8A130.69,130.69,0,0,1,209.48,27.23Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M162.46,17.87c4.08.26,8.15.66,12.19,1.23,5.35.76,11.31,1.76,17.28,3.09a115.75,115.75,0,0,0-26.17-8l-2-.16Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M150.64,17.55l.58-4.16q-2.19-.06-4.41-.09h-.88l-.24,4.38Q148.17,17.57,150.64,17.55Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M145.7,17.67l.24-4.38q-9.31-.09-18,.44l1.21,5.44c1.59-.21,3.14-.41,4.64-.58C137.76,18.13,141.72,17.84,145.7,17.67Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M162.46,17.87,163.78,14q-6.13-.47-12.56-.66l-.58,4.16Q156.55,17.49,162.46,17.87Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#004256"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M220,169.33s7.64,5,11.3,4.6a80.35,80.35,0,0,1-14.46-11.13s-34.5-30.43-51.17,5.85C165.69,168.66,186.26,144.18,220,169.33Z",
    transform: "translate(-0.05 -0.02)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.92,
    cy: 170.62,
    rx: 7.75,
    ry: 5.88,
    transform: "translate(6.05 347.4) rotate(-89.29)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M72.65,161a80.35,80.35,0,0,1-14.73,10.77c3.64.45,11.41-4.32,11.41-4.32,34.36-24.31,54.33.67,54.33.67C107.89,131.45,72.65,161,72.65,161Z",
    transform: "translate(-0.05 -0.02)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.51,
    cy: 167.75,
    rx: 7.75,
    ry: 5.88,
    transform: "translate(-60.62 274.15) rotate(-89.29)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M143.34,250.42c-.85,1.51-3.38,1-9.86-.18,3.1,1.41,7.65,3.29,9.74,3.33s6.58-1.67,9.65-2.94C146.4,251.67,144.15,252,143.34,250.42Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#fff"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M132.45,249.54l21.42.39a1.56,1.56,0,0,1,0,.28l.69-.3c-1.47-1.22-6.34-5-8.85-3.7-.48.24-1.74,1.09-2.35,1.5-.6-.43-1.84-1.31-2.31-1.56-2.47-1.33-7.65,2.15-9.26,3.31l.66.31Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M143.34,250.42c.81,1.53,3.06,1.25,9.53.22l1-.42a1.56,1.56,0,0,0,0-.28l-21.42-.39v.23l1,.47C140,251.46,142.49,251.93,143.34,250.42Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M150.55,255.34q.71-.55,1.42-1.23a1.88,1.88,0,0,0-1.35-.78c-4.44,1.72-12,2.58-17.49-1.43-.56-.41-.63-1-.67-1.85l-1.17-.22.5-.37-1.51-.73s8.58,14.78,19.53,7.14c-.62-.26-1.24-.54-1.38-.58A6.23,6.23,0,0,1,150.55,255.34Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M154.57,249.92l.44.38-1.16.19a3,3,0,0,1-1.52,2.07,2.92,2.92,0,0,1,.76.42,32.58,32.58,0,0,0,2.89-3.67Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M143.22,253.57c-2.09,0-6.63-1.93-9.74-3.33l-1-.19c0,.85.11,1.44.67,1.85,5.51,4,13,3.15,17.49,1.43-.46-.11-1-.19-1.41-.33.29-.09,1.16-.75,1.48-.75a4.84,4.84,0,0,1,1.64.29,3,3,0,0,0,1.52-2.07l-1,.16C149.8,251.9,145.27,253.61,143.22,253.57Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M132.47,250.05c0-.09,0-.18,0-.28l-.66-.31-.5.37Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M153.85,250.48l1.16-.19-.44-.37-.69.3A2.37,2.37,0,0,1,153.85,250.48Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M132.46,249.77c0,.1,0,.19,0,.28l1,.19Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87,250.63l1-.16a2.37,2.37,0,0,0,0-.27Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#db3d35"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M152,254.11a1.14,1.14,0,0,1,.14.56c0,.74-.72.76-1.56.67-.24.19-.49.37-.73.54a7.59,7.59,0,0,0,1.34.49c1.69,0,2.74,0,2.76-1.68a2.05,2.05,0,0,0-.83-1.72Q152.53,253.58,152,254.11Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#2c2c2c"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M152,252.74c-.41.2-.87.4-1.35.59a1.88,1.88,0,0,1,1.35.78q.56-.53,1.12-1.14a2.92,2.92,0,0,0-.76-.42Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#2c2c2c"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M148.44,255.3c.15,0,.77.32,1.38.58.24-.17.48-.35.73-.54A6.23,6.23,0,0,0,148.44,255.3Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#2c2c2c"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M149.22,253c.45.15.95.23,1.41.33.49-.19.95-.38,1.35-.59l.35-.2a4.84,4.84,0,0,0-1.64-.29C150.38,252.25,149.5,252.91,149.22,253Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#2c2c2c"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M287.36,301.85c.05-.6.1-1.22.15-1.85h-.21Q287.33,300.92,287.36,301.85Z",
    transform: "translate(-0.05 -0.02)",
    fill: "#cf252a"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFuriaHead, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/furia-head.1bb212ee.svg";
export { ForwardRef as ReactComponent };